import { SvgArrow2, SvgReward2, SvgVolumeIcon } from '@/assets/icon';
import icon from '@/assets/png/trading-challenge-icon.png';
import iconWld from '@/assets/png/wld.png';
import { formatDisplay } from '@/utils/format-display';
import clsx from 'clsx';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { ExpandableText } from '../ExpandableText';
import Loading from '../loading/skeleton';
import { useGetDataVolume } from './hooks/useGetDataVolume';
import { useTradingCampaignVolume } from './hooks/useTradingCampaigns';

const VolumeProgressCard = () => {
    const { t, i18n } = useTranslation();
    const { currentVolume, currentHighestTarget, isLoading } =
        useGetDataVolume();

    const { data } = useTradingCampaignVolume();

    const progressPercent = useMemo(() => {
        if (!currentVolume || !currentHighestTarget) {
            return 0;
        }
        return Math.min(
            100,
            (Number(currentVolume || 0) / currentHighestTarget) * 100
        );
    }, [currentHighestTarget, currentVolume]);

    const formatVolume = (volume: number): string => {
        return volume.toLocaleString('en-US');
    };

    return (
        <div className="bg-dark-bg px-4 pt-2 rounded-xl text-white">
            {/* Header Info (Giữ nguyên) */}
            <div className="flex justify-between items-start mb-5">
                <div className="max-w-[calc(100%-82px)] flex-1">
                    <h2 className="text-xl font-medium mb-1">
                        {' '}
                        {data?.campaign.title?.[i18n.language] ||
                            data?.campaign.title?.en}
                    </h2>

                    <Loading isLoading={isLoading}>
                        <ExpandableText
                            text={
                                data?.campaign?.description?.[i18n.language] ||
                                data?.campaign?.description?.en ||
                                ''
                            }
                        />
                    </Loading>
                </div>
                {/* Placeholder Image (Giữ nguyên) */}
                <img src={icon} className="w-[82px] h-[82px]" alt="" />
            </div>

            {/* Progress Section */}
            <div className="pt-3 border-b pb-5 border-[#191919]">
                {/* Labels */}
                <div className="flex justify-between text-xs text-gray-400  gap-x-2 mb-4">
                    <div className="flex items-center text-green1 gap-x-1 font-semibold">
                        <SvgVolumeIcon color="#38F24A" />{' '}
                        <span>{t('Volume')}</span>
                    </div>
                    {/* Icon Arrow */}
                    <div className="flex items-center gap-x-1 flex-1">
                        <div className="bg-[#292929] h-[1px] flex-1" />
                        <SvgArrow2 />

                        <div className="bg-[#292929] h-[1px] flex-1" />
                    </div>
                    <div className="flex items-center gap-x-1 text-white">
                        <SvgReward2 /> {t('Reward')}
                    </div>
                </div>

                {/* Progress Bar */}
                <div className="bg-[#292929] h-2 rounded-full mb-3 overflow-hidden">
                    <div
                        className="bg-green1 h-full transition-all duration-500 ease-out"
                        style={{ width: `${progressPercent}%` }}
                    ></div>
                </div>

                {/* Current Volume */}
                <div className="flex justify-between">
                    <p className="text-sm text-left flex-1  text-[#808080]">
                        {t('Current Volume')}{' '}
                    </p>

                    <Loading
                        isLoading={isLoading}
                        className={clsx({ '!w-[150px]': isLoading })}
                    >
                        <div className="flex items-center gap-x-1">
                            <span className="font-medium text-white">
                                {formatDisplay(Number(currentVolume || 0), {
                                    decimalToShow: 2,
                                })}
                                /{formatVolume(currentHighestTarget)} WLD
                            </span>
                            <img src={iconWld} className="w-4 h-4" alt="" />
                        </div>
                    </Loading>
                </div>
            </div>
        </div>
    );
};

export default VolumeProgressCard;
